import { VpnBlockScreen } from './VpnBlockScreen';
import { getVpnStatus } from '../queries';

export const VpnBlockScreenContainer = () => {
  const { isUsingVpn } = getVpnStatus();

  return <VpnBlockScreen isVisible={isUsingVpn} />;
};
